import GuideLayout from '@/components/Guides/GuideLayout';
import { ThemeProvider } from '@/context/ThemeContext';

export default function LearnLayout() {
  return (
    <ThemeProvider forceTheme="white" scoped>
      <GuideLayout guideType="learn" />
    </ThemeProvider>
  );
}
